<template>
  <div>
    <div
      v-if="loading"
      class="h-64 p-32 flex justify-center items-center"
    >
      <vue-element-loading
        :active="loading"
        spinner="spinner"
        color="#DBDBDB"
        background-color="rgba(255, 255, 255, .5)"
      />
    </div>
    <div v-else>
      <div
        class="container px-6 mt-4"
        v-if="answers_user.ideal_couple"
      >
        <h1 class="uppercase text-lg pl-0 md:pl-6 font-bold">
          <span class="text-pink-500">4.</span>
          {{ $t('messages.profile_tabs.steps.my_ideal_couple') }}
        </h1>
        <div
          class="flex mt-6 flex-wrap items-end"
          v-for="(item,i) in answers_user.ideal_couple.subcategories"
          :key="i"
        >
          <h1 class="uppercase text-lg text-blue-500 mt-6 pl-0 md:pl-6 font-bold w-full">{{ item.name[locale] }}</h1>

          <div class="w-full lg:w-1/2 px-0 lg:px-6 py-2 mb-5" v-if="item.id === 6">
            <p class="font-semibold mb-4 text-sm lg:text-lg xl:text-lg">{{ $t('messages.general.age_range') }}</p>
            <div class="px-4 slider-alter">
              <vue-slider
                v-model="range_age"
                :tooltip="'always'"
                :tooltip-placement="['bottom', 'bottom']"
                :enable-cross="false"
                :min="18"
                @change="(value) => onRangeChange(value)"
                color="#333"
              >
                <template v-slot:dot="{ value, focus }">
                  <div :class="['custom-dot', { focus }]"></div>
                </template>
                <template v-slot:tooltip="{ value, focus }">
                  <div
                    :class="['custom-tooltip', { focus }]"
                    class="font-semibold"
                  >{{ value }}</div>
                </template>
              </vue-slider>
            </div>
          </div>

          <template v-for="question in item.questions">
            <question-profile
              :question="question.title"
              :typeQuestion="question.type_question"
              :placeholder="question.placeholder"
              :questionOption="question.options"
              :answer="question.answer"
              :vvScope="vvScope"
              :validations="{ required: false}"
              :name="question.title"
              :width="question.width"
              :key="question.id"
              :id="question.id"
              :meta="item.key"
            ></question-profile>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QuestionProfile from "@/components/QuestionProfile.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import bus from "@/bus";

export default {
  name: "StepFour",
  props: ["clickedNext", "currentStep", "loading"],
  mixins: [validationMixin],
  componets: {
    QuestionProfile
  },
  data: function() {
    return {
      vvScope: "step4",
      form: {
        name: ""
      },
      range_age: [18, 80]
    };
  },

  mounted() {
    const { start_age, end_age } = this.user.profile;

    this.range_age = [start_age, end_age];
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("answers", ["answers_user"]),
    ...mapState("locale", ["locale"])
  },
  methods: {
    ...mapActions("auth", ["fetchUser"]),
    ...mapActions("answers", ["showAnswersUsers"]),
    async showAnswer() {},
    onRangeChange(value) {
      bus.$emit('age_range_changed', value);
    }
  },
  async created() {
    await this.showAnswersUsers(this.user.id);
  }
};
</script>
<style scoped>
#dropzone >>> .dz-message {
  display: flex !important;
  justify-content: center !important;
  width: 100% !important;
}
</style>
<style lang="scss" scoped>
#dropzone {
  background-color: #f6f6f6 !important;
  .dz-message {
    //width: 30%;
    padding: 10px;
    background-color: #f35a78;
    color: white;
    font-weight: 600;
  }
}
</style>
